import React from 'react';
import { TableCol as New } from './TableCol';
import { convertOldTableColProps, OldTableColProps } from './converter.old';

export type TableColProps = OldTableColProps;
export const TableCol = React.forwardRef<HTMLTableCellElement, TableColProps>((props, ref) => (
  <New {...convertOldTableColProps(props)} ref={ref} />
));

TableCol.displayName = 'TableCol';
